/**
 *
 * ModalCreateUser
 *
 */

import React from "react"
import alertSvg from "images/alert.svg"
import ModalCustom from "components/ModalCustom"
import { createAmbassadorApi } from "services/ambassador"
import { flatMap, isEqual } from "lodash"
import { Checkbox, Popover, Select, Input } from "antd"
import { QuestionCircleFilled } from "@ant-design/icons"
import { getLanguageWatcher } from "containers/DivisionEdit/actions"
import { Form } from "@ant-design/compatible"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class ModalAmbassadorAssign extends React.Component {
  state = { isLoading: false, checkSendInvitation: true, actual_language: undefined, }
  constructor(props) {
    super(props)
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
  }

  componentDidMount() {
    this.props.getLanguage && this.props.getLanguage()
  }
  handleChangeLanguage = (value) => {
    this.setState({ actual_language: value })
  }
  componentDidUpdate = (prevProps) => {
    const { checkSendInvitation } = this.props
    if (!isEqual(prevProps.checkSendInvitation, checkSendInvitation)) {
      this.setState({
        checkSendInvitation,
      })
    }
  }

  sendCreateServer = async () => {
    try {
      this.setState({ isLoading: true })
      let { selectedEmployee, selectedDivision } = this.props
      if (!Array.isArray(selectedDivision)) {
        selectedDivision = selectedDivision ? [selectedDivision] : []
      }
      if (!Array.isArray(selectedEmployee)) {
        selectedEmployee = selectedEmployee ? [selectedEmployee] : []
      }
      const response = await createAmbassadorApi({
        divisions: flatMap(selectedDivision, (item) => {
          return { id_division: item.id_division }
        }),
        employees: flatMap(selectedEmployee, (item) => {
          return { id_employee: item.id_employee }
        }),
        send_invitation: this.state.checkSendInvitation,
        id_language: this.state.actual_language || undefined,
      })
      this.props.onFinish(response.data.data.result)
      this.setState({ isLoading: false, checkSendInvitation: true })
      returnMessage(response)
    } catch (e) {
      this.setState({ isLoading: false, checkSendInvitation: true })
      returnMessage(e)
    }
  }

  renderIconQuestion = () => {
    return (
      <Popover
        placement="top"
        content={
          <div style={{ maxWidth: 245, textAlign: "center" }}>
            El embajador recibirá un{" "}
            <b>
              correo de
              <br /> invitación
            </b>{" "}
            al sistema al ser asignado.
          </div>
        }>
        <QuestionCircleFilled className="ModalAmbassadorAssign-icon-question" />
      </Popover>
    )
  }

  closeModal = () => {
    this.props.onCancel()
    this.setState({ isLoading: false, checkSendInvitation: true })
  }
verifyDisabledButton = () => {
  
  if(this.state.checkSendInvitation == true && this.state.actual_language == undefined){
    return true
  }
  if(this.state.checkSendInvitation == false){
    return false
  }
}
  render() {
    let { open, selectedEmployee, selectedDivision } = this.props
    let { checkSendInvitation } = this.state
    if (!Array.isArray(selectedDivision)) {
      selectedDivision = selectedDivision ? [selectedDivision] : []
    }
    if (!Array.isArray(selectedEmployee)) {
      selectedEmployee = selectedEmployee ? [selectedEmployee] : []
    }
    return (
      <ModalCustom
        onCancel={this.closeModal}
        onOk={() => {
          this.sendCreateServer()
        }}
        modalOpen={open}
        showFooter
        textButton="Asignar"
        disabledButton={this.verifyDisabledButton()}
        isLoadingButton={this.state.isLoading}>
        <div className="component-deletesimple">
          <img src={alertSvg} className="alertIcon" />
          <div className="component-deletesimple__description">
            <b>
              ¿Estás seguro que deseas asignar a{" "}
              {selectedEmployee.length > 0 && selectedEmployee.length === 1
                ? selectedEmployee[0].first_name
                : " los colaboradores"}{" "}
              como{" "}
              {selectedEmployee.length > 0 && selectedEmployee.length === 1
                ? "embajador"
                : "embajadores"}{" "}
              de{" "}
              {selectedDivision.length > 0 && selectedDivision.length === 1
                ? selectedDivision[0].name
                : "las divisiones"}
              ?
            </b>
            <br />
            <br />
            <p>
              Si el checkbox está activado, se activará un correo de invitación
              a la plataforma para el usuario, quien podrá visualizar los
              resultados de su división, si es que existieran.
            </p>
            {this.props.showCheckBox && (
              <>
                <br />
                <div className="ModalAmbassadorAssign-checkbox">
                  <Checkbox
                    onChange={(e) =>
                      this.setState({
                        checkSendInvitation: e.target.checked,
                      })
                    }
                    checked={checkSendInvitation}>
                    Enviar correo de invitación al sistema{" "}
                    {this.renderIconQuestion()}
                  </Checkbox>

                </div>

              </>
            )}

          </div>

        </div>
        {this.state.checkSendInvitation && (
          <>
            <Input.Group compact>
              <Form.Item style={{ width: "60%", textAlign: "left", float: "left", marginTop: "5px", marginLeft: "10px" }}>
                <Select
                  placeholder="Seleccionar idioma del correo"
                  value={this.state.actual_language}
                  style={{ width: "100%" }}
                  onChange={this.handleChangeLanguage}>
                  {/*  <Option value="Español">Español</Option> */}
                  {this.props.languages?.map((language) => (
                    <Select.Option
                      key={`language-${language.id_language}`}
                      value={language.id_language}>
                      {language.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Input.Group>
          </>
        )}
      </ModalCustom>
    )
  }
}

ModalAmbassadorAssign.propTypes = {}
ModalAmbassadorAssign.defaultProps = {
  showCheckBox: true,
  checkSendInvitation: true,
}

export default ModalAmbassadorAssign
